/* eslint-disable import/prefer-default-export */
import StringUtil from '@leverege/string-util'

export function getVariant( type, value, dVal ) {
  return `${type}${( value || dVal ) ? `${StringUtil.capitalize( value || dVal )}|${type}` : ''}`
}
